<template>
  <div class="team-efficiency-heatmap" ref="chartRef" style="width: 100%; height: 300px;"></div>
</template>

<script>
import * as echarts from 'echarts'
import { getTeamEfficiencyHeatmap } from "../api";
import { extractTitleAndValueArrays } from "@/basic-common/util/common";
export default {
  name: 'TeamEfficiencyHeatmap',
  inject: ['parentThat'],
  data () {
    return {
      chart: null
    };
  },
  mounted () {
    this.chart = echarts.init(this.$refs.chartRef);
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize);
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    initChart () {
      const { queryForm } = this.parentThat
      getTeamEfficiencyHeatmap(queryForm).then(({ data }) => {
        const {teamNames,data:dataList} = data.data
        this.setOption(teamNames,dataList)
      })
    },
    setOption (title,data) {
      const option = {
        title: {
          text: '班组效率分布热力图',
          left: '10%',
          top: '5%'
        },
        xAxis: {
          type: 'category',
          data: ['60分以下', '60-70分', '70-80分', '80-90分', '90分以上'],
          axisLabel: {
            interval: 0
          }
        },
        yAxis: {
          type: 'category',
          data: title,
          inverse: true
        },
        visualMap: {
          min: 1,
          max: 9,
          calculable: true,
          orient: 'horizontal',
          left: 'center',
          bottom: '10%',
          color: ['#fff2cc', '#f56b2a']
        },
        series: [
          {
            type: 'heatmap',
            data,
            // data: [
            //   [60, 0, 4], [0, 1, 2], [0, 2, 6], [0, 3, 5], [0, 4, 3],
            //   [1, 0, 3], [1, 1, 1], [1, 2, 5], [1, 3, 7], [1, 4, 4],
            //   [2, 0, 2], [2, 1, 4], [2, 2, 7], [2, 3, 3], [2, 4, 8],
            //   [3, 0, 1], [3, 1, 6], [3, 2, 9], [3, 3, 4], [3, 4, 5],
            //   [4, 0, 5], [4, 1, 7], [4, 2, 3], [4, 3, 8], [4, 4, 2]
            // ],
            label: {
              show: true
            },
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      this.chart.setOption(option);
    },
    handleResize () {
      if (this.chart) {
        this.chart.resize();
      }
    }
  }
};
</script>